module.exports = __webpack_public_path__ + "img/aro-kraken.83653f87.png";